import React, { useCallback, useEffect, useState } from 'react'
import './ManageCoral.css'

import { Box, Grid, InputAdornment, TextField, Typography } from '@mui/material'

import { useNavigate } from 'react-router-dom';

import DataTable from '../../components/DataTable/DataTable'
import OptionButton from '../../components/OptionButton/OptionButton';
import DeleteButton from '../../components/TableButton/DeleteButton';
import EditButton from '../../components/TableButton/EditButton';
import StatusButton from '../../components/TableButton/StatusButton';
import ExcelButton from '../../components/ExcelButton/ExcelButton';

import { surveyAreaServices } from '../../services/surveyAreaServices';

import useDataTable from '../../hooks/useDataTable';
import useErrorHandler from '../../hooks/useErrorHandler';

const columns = [
    {
        field: 'row_num',
        headerName: 'ลำดับ',
        headerAlign: 'center',
        align: 'center',
        sortable: false,
    },
    {
        field: 'province',
        headerName: 'จังหวัด',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
        valueGetter: (param) => param.row.AreaBoundary.target_area
    },
    {
        field: 'survey_area_name',
        headerName: 'พื้นที่สำรวจ',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
    },
    {
        field: 'table_status',
        headerName: 'สถานะ',
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        renderCell: (param) => {
            const data = { ...param.row, id: param.row.survey_area_code };
            return <StatusButton data={data} service={surveyAreaServices.updateStatus} />
        }
    },
    {
        field: 'edit',
        headerName: 'แก้ไข',
        headerAlign: 'center',
        type: 'actions',
        sortable: false,
        renderCell: (param) => <EditButton id={param.row.survey_area_code} formURL="manage-coral-form" />
    },
    {
        field: 'delete',
        type: 'actions',
        sortable: false,
        renderCell: (param) => (
            <DeleteButton
                id={param.row.survey_area_code}
                keyName='survey_area_code'
                service={surveyAreaServices.deleteSurveyAreaByCode}
            />
        )
    },
];

const initFilters = {
    search: '',
    dateFrom: '',
    dateTo: '',
}

function ManageCoral() {
    const navigate = useNavigate();

    const { paginationModel, resetPage } = useDataTable();
    const { errorHandler } = useErrorHandler();

    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [filters, setFilters] = useState(initFilters);
    const [paginationfilters, setPaginationFilters] = useState(initFilters);

    const getAllSurveyArea = useCallback(async (currentFilters) => {
        try {
            const res = await surveyAreaServices.getAllSurveyArea(currentFilters);
            console.log(res);
            if (res.status === 200) {
                setRows(res.data.data);
                setRowCount(res.data.rowCount);
            }
        } catch (error) {
            console.log(error);
            const { status, data } = error.response;
            errorHandler(
                'error: getAllSurveyArea',
                status,
                data.message
            );
        }
    }, []);

    useEffect(() => {
        getAllSurveyArea({ ...paginationfilters, ...paginationModel });
    }, [paginationModel.page, paginationfilters])

    const handleAddClick = () => navigate('/dashboard/manage-coral-form');

    const handleFilterChange = ({ target }) => {
        const { name, value } = target;
        console.log(value);

        setFilters(prev => {
            return {
                ...prev,
                [name]: value,
            }
        });
    }

    const handleSearchClick = () => {
        console.log(filters);
        setPaginationFilters({ ...filters });
        resetPage();
    }

    const handleClearClick = () => {
        setFilters({ ...initFilters });
        setPaginationFilters({ ...initFilters });
        resetPage();
    }

    return (
        <div className="manage-coral">
            <Grid container className="filters" gap={1}>
                <Grid container item md={12} display="flex" alignItems="center">
                    <Grid item md={1}>
                        <Typography>ค้นหา</Typography>
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            name="search"
                            value={filters.search}
                            onChange={handleFilterChange}
                        />
                    </Grid>
                </Grid>
                <Grid container item md={12} display="flex" alignItems="center">
                    <Grid item md={1}>
                        <Typography>วันที่เพิ่ม</Typography>
                    </Grid>
                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            type="date"
                            size="small"
                            name="dateFrom"
                            value={filters.dateFrom}
                            onChange={handleFilterChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box>From</Box>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            type="date"
                            size="small"
                            name="dateTo"
                            value={filters.dateTo}
                            onChange={handleFilterChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box>To</Box>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container className="options">
                <Grid item md={1}></Grid>
                <Grid
                    item xs={12} md={6}
                    sx={{
                        '& button': { width: '25%' },
                        '& :not(:nth-of-type(1))': { ml: 2 }
                    }}
                >
                    <OptionButton
                        text='ค้นหา'
                        bgColor='var(--options-btn-bg-color-1)'
                        hoverColor='var(--options-btn-bg-hover-1)'
                        onClick={handleSearchClick}
                    />
                    <OptionButton
                        text='ล้าง'
                        bgColor='var(--options-btn-bg-color-2)'
                        hoverColor='var(--options-btn-bg-hover-2)'
                        textColor='gray'
                        onClick={handleClearClick}
                    />
                    <OptionButton
                        text='เพิ่ม'
                        bgColor='var(--options-btn-bg-color-1)'
                        hoverColor='var(--options-btn-bg-hover-1)'
                        onClick={handleAddClick}
                    />
                </Grid>

                <ExcelButton modelName="SurveyArea" importCallback={handleClearClick} />
            </Grid>

            <DataTable
                columns={columns}
                rows={rows}
                rowCount={rowCount}
                getRowId={(row) => row.survey_area_code}
                pageProps={paginationModel}
            />
        </div>
    )
}

export default ManageCoral